<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :caption="caption"
    :disabled="disabled"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :tabbed="tabbed"
    :definition="{}"
    :editor-is-popup="editorIsPopup"
    :on-create="handleCreate"
    :on-edit="handleEdit"
    :on-table-row-double-click="null"
    :show-edit="() => {}"
    :show-create="() => {}"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [baseCrudMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    columns: {
      default: () => [
        'name',
        { field: 'code', label: 'store.code' },
        'description',
        { field: 'storeAttributeName', label: 'store.attribute' },
        { field: 'storeTypeName', label: 'store.type' },
        { field: 'height', label: 'store.height' },
        'phone',
        'email',
        { field: 'globalLocationNumber', filter: { type: 'none' }, sortable: false }
      ],
      type: Array
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    tabbed: {
      default: true,
      type: Boolean
    },
    editorIsPopup: {
      type: Boolean,
      default: false
    },
    domainID: Number
  },
  data: () => ({
    entity: 'Store',
    returnTo: 'Stores'
  }),
  computed: {
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  created() {
    this.$store.dispatch('country/getItems');
  },
  methods: {
    generateSummary(row) {
      return `${row.name}`;
    },
    handleCreate() {
      this.onCreate
        ? this.onCreate()
        : this.$router.push({
            name: 'Create' + this.entity,
            params: { clientID: this.$route.params.id, domainID: this.domainID }
          });
      this.$emit('create');
    },
    handleEdit(row) {
      const { id } = row;
      const params = {
        id: id,
        clientID: +this.$route.params.id,
        domainID: this.domainID
      };
      this.onEdit
        ? this.onEdit(row)
        : this.$router.push({
            name: 'Edit' + this.entity,
            params: params
          });
      this.$emit('edit', id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
